import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import { Link } from "react-router-dom";
import img1 from "../../assets/images/KhojPartners/developer.png";
import img2 from "../../assets/images/KhojPartners/darwinbox.png";
import img3 from "../../assets/images/KhojPartners/mankeen.png";
import img4 from "../../assets/images/KhojPartners/ica.png";
import img5 from "../../assets/images/KhojPartners/credent.png";
import img6 from "../../assets/images/KhojPartners/canon.png";
import img7 from "../../assets/images/KhojPartners/axisbank.png";
import img8 from "../../assets/images/KhojPartners/oyo.png";
import img9 from "../../assets/images/KhojPartners/saint.png";
import img10 from "../../assets/images/KhojPartners/shivalik.png";
import img11 from "../../assets/images/KhojPartners/birlaopus.png";
import img12 from "../../assets/images/KhojPartners/indiadatahub.png";
import img13 from "../../assets/images/KhojPartners/axismutualfund.png";

import img14 from "../../assets/images/KhojPartners/developerdark.png";
import img15 from "../../assets/images/KhojPartners/darwinboxdark.png";
import img16 from "../../assets/images/KhojPartners/mankeendark.png";
import img17 from "../../assets/images/KhojPartners/icadark.png";
import img18 from "../../assets/images/KhojPartners/credentdark.png";
import img19 from "../../assets/images/KhojPartners/canondark.png";
import img20 from "../../assets/images/KhojPartners/axisbankdark.png";
import img21 from "../../assets/images/KhojPartners/oyodark.png";
import img22 from "../../assets/images/KhojPartners/saintdark.png";
import img23 from "../../assets/images/KhojPartners/shivalikdark.png";
import img24 from "../../assets/images/KhojPartners/birlaopusdark.png";
import img25 from "../../assets/images/KhojPartners/indiadatahubdark.png";
import img26 from "../../assets/images/KhojPartners/axismutualfunddark.png";
import useLocalStorage from "use-local-storage";

const dataPartner = [
  {
    id: 1,
    img: img1,
  },
  {
    id: 2,
    img: img2,
  },
  {
    id: 3,
    img: img3,
  },
  {
    id: 4,
    img: img4,
  },
  {
    id: 5,
    img: img5,
  },
  {
    id: 6,
    img: img6,
  },
  {
    id: 7,
    img: img7,
  },
  {
    id: 8,
    img: img8,
  },
  {
    id: 9,
    img: img9,
  },
  {
    id: 10,
    img: img10,
  },
  {
    id: 11,
    img: img11,
  },
  {
    id: 12,
    img: img12,
  },
  {
    id: 13,
    img: img13,
  }
];
const dataPartnerDark = [
  {
    id: 14,
    img: img14,
  },
  {
    id: 15,
    img: img15,
  },
  {
    id: 16,
    img: img16,
  },
  {
    id: 17,
    img: img17,
  },
  {
    id: 18,
    img: img18,
  },
  {
    id: 19,
    img: img19,
  },
  {
    id: 20,
    img: img20,
  },
  {
    id: 21,
    img: img21,
  },
  {
    id: 22,
    img: img22,
  },
  {
    id: 23,
    img: img23,
  },
  {
    id: 24,
    img: img24,
  },
  {
    id: 25,
    img: img25,
  },
  {
    id: 26,
    img: img26,
  },

];
function Partner() {
  const [isDark] = useLocalStorage("isDark", false);
  return (
    <section>
      <div className="wd-partner style-1  ">
        <div className="container">
          <h1 className="title-partner">
           Our Clients
          </h1>

          <Swiper
            modules={[Autoplay]}
            spaceBetween={68.95}
            slidesPerView={6}
            autoplay={{
              delay: 1,
              disableOnInteraction: true,
            }}
            className="partner-type-7"
            loop={true}
            speed={3000}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              500: {
                slidesPerView: 3,
              },
              800: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1600: {
                slidesPerView: 7,
              },
            }}
          >
            {isDark ? (dataPartnerDark.map((item) => (
              <SwiperSlide key={item.id}>
                <Link to="#" className="logo-partner">
                  <img src={item.img} alt="img" />
                </Link>
              </SwiperSlide>
            ))) : dataPartner.map((item) => (
              <SwiperSlide key={item.id}>
                <Link to="#" className="logo-partner">
                  <img src={item.img} alt="img" />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Partner;
